import type { ClassAttributes, InputHTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import type { Theme } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled, { type StyledComponent } from '@emotion/styled';

import { token } from '@atlaskit/tokens';

import { enlargedInputFieldHeight, inputFieldHeight } from '../style-utils';
import type { SearchCSS } from '../theme';
import { type IsExpandedProp, SearchInputField } from './search-input.styled';

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EnlargedSearchInputField: StyledComponent<
	{
		theme?: Theme;
		as?: React.ElementType;
	} & SearchCSS &
		IsExpandedProp &
		ClassAttributes<HTMLInputElement> &
		InputHTMLAttributes<HTMLInputElement> & {
			theme?: Theme;
		},
	{},
	{}
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-dynamic-styles
> = styled(SearchInputField)<SearchCSS & IsExpandedProp>((props) => ({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	height: props.isExpanded ? enlargedInputFieldHeight.px : inputFieldHeight.px,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
	borderRadius: props.isExpanded ? token('radius.large') : token('radius.medium'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	padding: props.isExpanded
		? `${token('space.150')} 52px ${token('space.150')} 52px`
		: `0px ${token('space.300')} 0px 30px`,
	'&:focus': {
		border: 'none',
		boxShadow: token('elevation.shadow.overlay'),
	},
}));
